import { DataPointName } from '@front-app/hooks/DataDashboard/model';

export interface DataTableColumn {
	dateTitle: string;
	totalTitle: string;
	windowedAverageTitle: string;
	dataPointTitles: DataPointTitle[];
}

export interface DataPointTitle {
	dataPoint: DataPointName;
	title: string;
}

export enum SortDirection {
	ASC = 'asc',
	DESC = 'desc',
}
